import { render, staticRenderFns } from "./AssignProductTier.vue?vue&type=template&id=13a6a204"
import script from "./AssignProductTier.vue?vue&type=script&lang=js"
export * from "./AssignProductTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports